var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.344,
    height: 12.1,
    viewBox: "0 0 14.344 12.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gold_crown",
    "data-name": "gold crown",
    d: "M16435.727,17684.1a.716.716,0,0,1-.68-.475l-3-8.414a.73.73,0,0,1,1.109-.84l2.885,2.068a.714.714,0,0,0,1.092-.338l1.371-3.629a.721.721,0,0,1,1.354,0l1.367,3.639a.725.725,0,0,0,1.1.332l2.891-2.062a.713.713,0,0,1,1.086.83l-3,8.414a.722.722,0,0,1-.68.475Z",
    transform: "translate(-16431.998 -17672)",
    fill: "#f4900c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCrown);
export default __webpack_public_path__ + "static/media/gold-crown.75eeba13ed92d0c269424fc423542edf.svg";
export { ForwardRef as ReactComponent };